import { GetRecordByIdResult } from '@indigohive/cogfy-types/endpoints/getRecordById'
import { GetCollectionFieldsResultData } from '@indigohive/cogfy-types/endpoints/getCollectionFields'
import { BooleanRecordProperty, UUID } from '@indigohive/cogfy-types'
import type { UpdateRecordPropertiesOperationData } from '@indigohive/cogfy-types/endpoints/transactions'
import { Checkbox } from '../../../components'

export type BooleanRecordPropertyInputProps = {
  collectionId: UUID
  field: Extract<GetCollectionFieldsResultData, { type: 'boolean' }>
  record: GetRecordByIdResult
  onUpdateRecordProperties?: (data: UpdateRecordPropertiesOperationData) => void
  disabled?: boolean
}

export function BooleanRecordPropertyInput (props: BooleanRecordPropertyInputProps) {
  const { collectionId, field, record, disabled } = props

  const property = record.properties[field.id] as BooleanRecordProperty | undefined

  return (
    <Checkbox
      size="sm"
      color="info"
      disabled={disabled}
      checked={property?.boolean?.value ?? false}
      onChange={event => {
        props.onUpdateRecordProperties?.({
          recordId: record.id,
          collectionId,
          properties: {
            [field.id]: {
              type: 'boolean',
              boolean: {
                value: event.target.checked
              }
            }
          }
        })
      }}
    />
  )
}
